/**
 * Utility function to determine if an array includes a specific element
 * @param {Array} array
 * @param {*} element
 * @returns boolean
 */
export function arrayIncludes(array, element) {
  return array.indexOf(element) > -1;
}
